import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { CommonService } from '../../../common.service';
declare var $: any;
@Component({
  selector: 'app-edit-animal-general',
  templateUrl: './edit-animal-general.component.html',
  styleUrls: ['./edit-animal-general.component.css']
})
export class EditAnimalGeneralComponent implements OnInit {
  getgeneraleditApi:any;
  putgeneraleditApi:any;
  EditDiseaseFormValue:any;
  loadspeciesValue:any;
  EditgeneralFormValue:any;
  getfarmlistdata:any;
  addUrl:any;
  getlistApi:any;
  getDiseaseListData:any;
  speciesloaddata:any;
  getspeciesvalue:any;
  loginresponse:any;
  cby_mby:any;
  returnUrl="/dashboard/RottweilerDogsAnimalmanagement"
  constructor(private router: Router,private commonService:CommonService) { }

 async ngOnInit()  {
  this.loginresponse=JSON.parse(sessionStorage.getItem('userrole'));
  this.cby_mby=this.loginresponse.user_id;
    $('.selectpicker').selectpicker('refresh'); 

    let GeneralId = sessionStorage.getItem('generalId');
    this.getgeneraleditApi= "/animal_management/general/"+ GeneralId;
    this.putgeneraleditApi= "/animal_management/general/"+ GeneralId;
    (await this.commonService.getApi(this.getgeneraleditApi)). subscribe(
      async (res:any) => {
      //  this.speciesloadid=res.data.tnsm_farm_id;
      var farmid=sessionStorage.getItem('farmid');
        this.getlistApi= "/species/farms";
        this.loadspeciesValue = {
          "farms_id":farmid
        };
            this.addUrl = "/species/farms";
            (await this.commonService.postApi(this.addUrl,this.loadspeciesValue)).subscribe(
              res => {
                this.speciesloaddata=res.data;
              })
            this.getfarmlistdata = res.data;
            console.log(this.getfarmlistdata);
         
          setTimeout(function () {
            $("#Speciesname .filter-option").text(res.data.species_name)
            $("select[name=Speciesname]").val(res.data.tnam_gen_species_id)
            $('.selectpicker').selectpicker('refresh');   // refresh the selectpicker with fetched courses
         }, 2000);
        this.addUrl = "/breeds/species/"+res.data.tnam_gen_species_id;
        (await this.commonService.getApi(this.addUrl)).subscribe(
          res => {
               this.getspeciesvalue=res.data;
              console.log(this.getspeciesvalue);
          });
          
          setTimeout(function () {
            $("#BreedName .filter-option").text(res.data.breed_name)
            $("select[name=BreedName]").val(res.data.tnam_gen_breed_id)
            $('.selectpicker').selectpicker('refresh');   // refresh the selectpicker with fetched courses
         }, 1000);
         $("#animalid").val(res.data.tnsm_animal_code)
      //  $("select[name=farmname]").val(res.data.tnsm_farm_id)
       // $("select[name=speciesname]").val(res.data.tnsm_species_id)
       $("#gender .filter-option").text(res.data.tnam_gen_sex)
       $("select[name=gender]").val(res.data.tnam_gen_sex)
        $("#animaltype").val(res.data.tnam_gen_type)
        $("#Age").val(res.data.tnam_gen_age_group)
        $("#Weight").val(res.data.tnam_gen_weight)
        var date=res.data.tnam_gen_date_of_birth;
        var birthdate = date.split('T');
        var transferdate=res.data.tnam_gen_date_of_transfer;
        var transfdate = date.split('T');
        var purchasedate=res.data.tnam_gen_date_of_purchase;
        var datepurchase = date.split('T');
        var deletiondate=res.data.tnam_gen_date_of_deletion;
        var datedelete = date.split('T');
        $("#birthdate").val(birthdate[0])
        $("#transferdate").val(transfdate[0])
        $("#purchasedate").val(datepurchase[0])
        $("#deletiondate").val(datedelete[0])
//        $( "#speciesEditId option:selected" ).text();
$('.selectpicker').selectpicker('refresh');
//$("#farmname .filter-option").text(res.data.tnsm_farm_id)
//$("#Speciesname .filter-option").text(res.data.tnsm_species_id)


      })
  }
  async breedselectbyspecies(event){
    console.log(event.target.value);
    this.addUrl = "/breeds/species/"+event.target.value;
    (await this.commonService.getApi(this.addUrl)).subscribe(
      res => {
           this.getspeciesvalue=res.data;
          console.log(this.getspeciesvalue);
      });
      setTimeout(function () {
        $('.selectpicker').selectpicker('refresh');   // refresh the selectpicker with fetched courses
     }, 1000);
}
  async AnimalGeneral(){
    var farmid=sessionStorage.getItem('farmid');
    var Animalid=sessionStorage.getItem('animalid');
    this.EditgeneralFormValue = {
      "species_id":$("#Speciesname").val(),
      "breed_id": $("#BreedName").val(),
      "farm_id":farmid,
      "animal_code":Animalid,
      "name":"name",
      "type":$("#animaltype").val(),
      "age_group":$("#Age").val(),
      "sex":$("#gender").val(),
      "weight":$("#Weight").val(),
      "date_of_birth": $("#birthdate").val(),
      "date_of_transfer": $("#transferdate").val(),
      "date_of_purchase": $("#purchasedate").val(),
      "date_of_deletion":$("#deletiondate").val(),
      "date_of_death":$("#deletiondate").val(),
      "cby": this.cby_mby,
      "mby":this.cby_mby,
      "status": 1,
      "is_active":1
     };
    
       (await this.commonService.putApi(this.putgeneraleditApi,this.EditgeneralFormValue)).subscribe(
         data => {
             alert("Data edited successfully");
         });
         setTimeout(
          () : void => {
    
            this.router.navigate([this.returnUrl]);
    
          },
          500
        );
  }
  backnavigate(){
    this.router.navigate([this.returnUrl]);
  }
}
